module.exports = __webpack_public_path__ + "static/media/placeholder-1.e2ef3a8f.png";